import { useDispatch, useSelector } from "react-redux";
import HomeGrid from "../../CustomHook/HomeGrid";
import Agent from "../../Network/Agent";
import { useCallback, useEffect, useRef, useState } from "react";
import CountdownTimer from "../../Props/CountdownTimer";
import { Link } from "react-router-dom";
import { RMS_ACTIVE_ALARM_FETCH_START } from "../../Reducer/RmsActiveAlarmSlice";
import { ACS_ACTIVE_ALARM_FETCH_START } from "../../Reducer/AcsActiveAlarmSlice";
import { RMS_ALARM_HISTORY_FETCH_START } from "../../Reducer/RmsAlarmHistorySlice";
import FilterRMS from "./FilterRms";
import FilterAcs from "./FilterAcs";
import { cancelAllRequests, createController } from "../../Network/API";
import { set } from "nprogress";


export default function FunctionalHome() {
    const dispatch = useDispatch();
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    const [page, setPage] = useState(1);
    const observer = useRef();
    const [active_rms_page, setActiveRmsPage] = useState(1);
    const activeRmsObserver = useRef();
    const [filter_type, setFilterType] = useState(1);
    //acs part start
    const [acs_filter_type, setAcsFilterType] = useState(1);
    const [acs_page, setAcsPage] = useState(1);
    const acsObserver = useRef();
    const [active_acs_page, setActiveAcsPage] = useState(1);
    const activeAcsObserver = useRef();

    const acs_form_data = useRef({
        site_id: "",
        site_code: "",
        tenant_id: "",
        alarm_type: "",
        from_date: "",
        to_date: "",
        start_date: "",
        end_date: "",
        filter_type: "",
        query: "",
        page: 1,
        loadMore: false,
        cluster: "",
        zone: "",
    });

    const array_data = useRef({
        'page': page,
        'site_code': "",
        'tenant_id': "",
        'cluster': "",
        'zone': "",
        'alarm_type': "",
        'start_date': "",
        'end_date': "",
        'filter_type': "",
        'query': "",
        'loadMore': false,
    });

    function FormattedNumber(number = 0) {
        if (number === null || number === undefined) {
            return 0;
        }
        const formatted = number.toLocaleString(); // or Intl.NumberFormat().format(number)
        return formatted;
    }


    const fetchAll = async () => {
        // 🔴 আগের সব request kill
        cancelAllRequests();

        const controller = createController();
        const signal = controller.signal;

        const tasks = [
            Agent.HOME.overview(dispatch, signal),

            delay(10).then(() =>
                Agent.RMS_ALARM.rms_active_alarm(dispatch, array_data?.current, signal)
            ),

            Agent.ACS_ALARM.acs_alarm_nav(dispatch, signal),
            Agent.RMS_ALARM.rms_alarm_type(dispatch, signal),

            delay(20).then(() =>
                Agent.ACS_ALARM.acs_active_alarm(dispatch, acs_form_data?.current, signal)
            ),

            delay(30).then(() =>
                Agent.RMS_ALARM.rms_alarm_history_new(dispatch, array_data?.current, signal)
            ),

            delay(40).then(() =>
                Agent.ACS_ALARM.lock_alarm_history(dispatch, acs_form_data?.current, signal)
            ),
        ];

        await Promise.allSettled(tasks);
    };

    async function fetchMoreData() {
        cancelAllRequests();

        const controller = createController();
        const signal = controller.signal;

        array_data.current.page = page;
        array_data.current.loadMore = true;

        dispatch(RMS_ALARM_HISTORY_FETCH_START());

        await Agent.RMS_ALARM.rms_alarm_history_new(
            dispatch,
            array_data?.current,
            signal
        );
    }


    async function fetchMoreDataActiveRms() {
        cancelAllRequests();

        const controller = createController();
        const signal = controller.signal;

        array_data.current.page = active_rms_page;
        array_data.current.loadMore = true;

        dispatch(RMS_ACTIVE_ALARM_FETCH_START());

        await Agent.RMS_ALARM.rms_active_alarm(
            dispatch,
            array_data?.current,
            signal
        );
    }


    useEffect(() => {
        Agent.HOME.Cluster(dispatch);
        fetchAll();

        return () => {
            // 🔴 page leave = STOP EVERYTHING
            cancelAllRequests();
        };
    }, []);


    useEffect(() => {

        if (page > 1) {
            fetchMoreData();
        }

    }, [page]);

    useEffect(() => {
        // console.log("active_rms_page changed:", active_rms_page);
        if (active_rms_page > 1) {
            fetchMoreDataActiveRms();
        }
    }, [active_rms_page]);



    const callbackSearch = (searchData) => {
        // console.log("Functional Home searchData:", searchData);
        array_data.current = {
            'page': searchData.page,
            'site_code': searchData.site_code,
            'site_id': searchData.site_id,
            'tenant_id': searchData.tenant_id,
            'alarm_type': searchData.alarm_type,
            'start_date': searchData.start_date,
            'end_date': searchData.end_date,
            'filter_type': searchData.filter_type,
            'query': searchData.query,
            'cluster': searchData.cluster ?? '',
            'zone': searchData.zone ?? '',
            'loadMore': false,
        }

      if(filter_type === 2){
        setPage(1);
        } else {
            setActiveRmsPage(1);
        }
      
     //  console.log("Functional Home searchData:", page);
    };

    const callBackAcsSearch = (searchData) => {
       // console.log("ACS Functional Home searchData:", searchData);
         acs_form_data.current = {
                'page': searchData.page,
                'site_code': searchData.site_code,
                'site_id': searchData.site_id,
                'tenant_id': searchData.tenant_id,
                'alarm_type': searchData.alarm_type,
                'start_date': searchData.start_date,
                'end_date': searchData.end_date,
                'filter_type': searchData.filter_type,
                'query': searchData.query,
                'cluster': searchData.cluster ?? '',
                'zone': searchData.zone ?? '',
                'loadMore': false,
            }
        if(acs_filter_type === 2){
            setAcsPage(1);
        } else {
            setActiveAcsPage(1);
        }
    };



    const selector = useSelector((state) => state.homeReducer)
    const alarms = selector?.data
    const rms_active_selector = useSelector((state) => state.rmsActiveAlarmSlice)
    const acs_active_selector = useSelector((state) => state.acsActiveAlarmSlice)
    const selector_rms_alarms = useSelector((state) => state.rmsAlarmHistoryReducer)


    const lastElementRef = useCallback((element) => {
        //element is the react element being referenced

        // disconnect observer set on previous last element
        if (observer.current) observer.current.disconnect();

        // if there's no more data to be fetched, don't set new observer
        if (!selector_rms_alarms?.data.has_more_page) return;

        // set new observer
        observer.current = new IntersectionObserver((entries) => {
            // increase page number when element enters (is intersecting with) viewport.
            // This triggers the pagination hook to fetch more items in the new page
            if (entries[0].isIntersecting && selector_rms_alarms?.data.has_more_page) setPage((prev) => prev + 1);
        });

        // observe/monitor last element
        if (element) observer.current.observe(element);
    }, [selector_rms_alarms?.data.has_more_page]);



    // for active rms alarm usecallback search
    const lastRmsActiveElementRef = useCallback((element) => {
        //element is the react element being referenced

        // disconnect observer set on previous last element
        if (activeRmsObserver.current) activeRmsObserver.current.disconnect();
        // if there's no more data to be fetched, don't set new observer
        if (!rms_active_selector?.data.has_more_page) return;

        // set new observer
        activeRmsObserver.current = new IntersectionObserver((entries) => {
            // increase page number when element enters (is intersecting with) viewport.
            // This triggers the pagination hook to fetch more items in the new page
            if (entries[0].isIntersecting && rms_active_selector?.data.has_more_page) setActiveRmsPage((prev) => prev + 1);
        });

        // observe/monitor last element
        if (element) activeRmsObserver.current.observe(element);
    }, [rms_active_selector?.data.has_more_page]);

    //acs part start

    const lock_alarm_history = useSelector((state) => state.lockAlarmHistoryReducer)

    const lastAcsActiveElementRef = useCallback((element) => {
        //element is the react element being referenced

        // disconnect observer set on previous last element
        if (activeAcsObserver.current) activeAcsObserver.current.disconnect();
        // if there's no more data to be fetched, don't set new observer
        if (!acs_active_selector?.data.has_more_page) return;

        // set new observer
        activeAcsObserver.current = new IntersectionObserver((entries) => {
            // increase page number when element enters (is intersecting with) viewport.
            // This triggers the pagination hook to fetch more items in the new page
            if (entries[0].isIntersecting && acs_active_selector?.data.has_more_page) setActiveAcsPage((prev) => prev + 1);
        });

        // observe/monitor last element
        if (element) activeAcsObserver.current.observe(element);
    }, [acs_active_selector?.data.has_more_page]);

    function fetchMoreDataActiveAcs() {

        cancelAllRequests();

        const controller = createController();
        const signal = controller.signal;

        acs_form_data.current.page = active_acs_page;
        acs_form_data.current.loadMore = true;
        dispatch(ACS_ACTIVE_ALARM_FETCH_START());
        Agent.ACS_ALARM.acs_active_alarm(dispatch, acs_form_data?.current, signal)
    }
    // acs active load more data
    useEffect(() => {
        // console.log("active_acs_page changed:", active_acs_page);
        if (active_acs_page > 1) {
            fetchMoreDataActiveAcs();
        }
    }, [active_acs_page]);

    // acs history element ref
    const lastAcsHistoryElementRef = useCallback((element) => {
        //element is the react element being referenced
        // disconnect observer set on previous last element
        if (acsObserver.current) acsObserver.current.disconnect();
        // if there's no more data to be fetched, don't set new observer
        if (!lock_alarm_history?.data.has_more_page) return;
        // set new observer
        acsObserver.current = new IntersectionObserver((entries) => {
            // increase page number when element enters (is intersecting with) viewport.
            // This triggers the pagination hook to fetch more items in the new page
            if (entries[0].isIntersecting && lock_alarm_history?.data.has_more_page) setAcsPage((prev) => prev + 1);
        });
        // observe/monitor last element
        if (element) acsObserver.current.observe(element);
    }, [lock_alarm_history?.data.has_more_page]);

    // acs history fetch more data
    function fetchMoreDataAcsHistory() {
        cancelAllRequests();

        const controller = createController();
        const signal = controller.signal;

        acs_form_data.current.page = acs_page;
        acs_form_data.current.loadMore = true;
        Agent.ACS_ALARM.lock_alarm_history(dispatch, acs_form_data?.current, signal)
    }

    useEffect(() => {
        if (acs_page > 1) {
            fetchMoreDataAcsHistory();
        }
    }, [acs_page]);

    return (
        <>
            <div className="container-fluid mt-2">
                <div className="row d-none">
                    <div className="col-12 mt-1 d-flex justify-content-between align-items-center">

                        <div></div>
                        <div>
                            <ul className="nav nav-pills custom-nav-pills" id="pills-tab" role="tablist">
                                <li className="nav-item me-2" role="presentation">
                                    <Link to={`/`} className="nav-link nav-link-custom" aria-selected="true">NOC Dashboard</Link>
                                </li>
                                {/* <li className="nav-item me-2" role="presentation">
                                <button className="nav-link nav-link-custom" id="pills-management-tab" data-bs-toggle="pill" data-bs-target="#pills-management" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Management Dashboard</button>
                            </li> */}
                                <li className="nav-item me-2" role="presentation">
                                    <Link to={`/functional_dashboard`} className="nav-link nav-link-custom active" role="tab" aria-controls="pills-contact" aria-selected="false">Functional Dashboard</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row g-2 mt-1 mb-2 ">
                    <HomeGrid title={`Total Site`} value={alarms?.total_sites} route={'#'} color={`bg-dark text-white`} icon={`fa-solid fa-map`} class={`shadow-dark`} valueColor={'text-dark'} />
                    {/* <HomeGrid title={`Total Lock`} value={alarms?.site_alarm?.length > 0 ? alarms?.site_alarm[0]?.total_site : 0} route={`/sites`} color={`bg-info text-white`} icon={`fa-solid fa-lock`} class={`shadow-info`} valueColor={'text-info'} /> */}
                    <HomeGrid title={`Total Online`} value={alarms?.site_alarm?.length > 0 ? alarms?.site_alarm[0]?.online_device : 0} route={'/online_sites'} color={`bg-green`} icon={`fa-regular fa-signal`} class={`shadow-green`} valueColor={'text-success'} />
                    <HomeGrid title={`Total Offline`} value={alarms?.site_alarm?.length > 0 ? alarms?.site_alarm[0]?.offline_device : 0} route={'/offline_sites'} color={`bg-secondary text-white`} icon={`fa-duotone fa-signal-slash`} class={`shadow-black`} valueColor={'text-gray'} />
                    <HomeGrid title={`Mains Fail`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.mains_fail : 0} route={'rms_alarm_filter/1/fatch'} color={`bg-danger text-white`} icon={`fa-regular fa-transformer-bolt `} class={`shadow-red`} />
                    <HomeGrid title={`DC Low`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.dc_low : 0} route={'rms_alarm_filter/2/fatch'} color={`bg-sapphire text-white`} icon={`fa-light fa-battery-quarter`} class={`shadow-sapphire`} />
                    {/* <HomeGrid title={`Overload`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.overloaded : 0} route={'rms_alarm_filter/25/fatch'} color={`bg-warning text-white`} icon={`fa-regular fa-chart-line-up`} class={`shadow-orange`} valueColor={'text-warning'} /> */}

                    <HomeGrid title={`No Load`} value={0} route={'rms_alarm_filter/26/fatch'} color={`bg-warning  text-dark`} icon={`fa-regular fa-chart-line-down`} class={`shadow-purple`} valueColor={'text-warning'} />
                    <HomeGrid title={`Site Down`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.load_disconnect : 0} route={'rms_alarm_filter/26/fatch'} color={`bg-red text-white`} icon={`fa-regular fa-chart-line-down`} class={`shadow-purple`} valueColor={'text-danger'} />

                    <HomeGrid title={`Door Open`} value={alarms?.site_alarm?.length > 0 ? alarms?.site_alarm[0]?.door_status : 0} route={'acs_alarm_filter/7/fatch'} color={`bg-purple text-white`} icon={`fa-regular fa-door-open`} class={`shadow-purple`} />
                    <HomeGrid title={`Lock Open`} value={alarms?.site_alarm?.length > 0 ? alarms?.site_alarm[0]?.lock_open_status : 0} route={'acs_alarm_filter/2/fatch'} color={`bg-orange text-white`} icon={`fa-regular fa-lock-open`} class={`shadow-orange`} valueColor={'text-warning'} />
                    <HomeGrid title={`Security Breach`} value={alarms?.site_alarm?.length > 0 ? alarms?.site_alarm[0]?.breach_status : 0} route={'acs_alarm_filter/6/fatch'} color={`bg-red text-white`} icon={`fa-regular fa-user-secret`} class={`shadow-danger  ${alarms?.site_alarm?.length > 0 ? alarms?.site_alarm[0]?.breach_status ? 'divAnimation' : `` : ``}`} />

                    <HomeGrid title={`MDB Fault`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.mdb_fault : 0} route={'rms_alarm_filter/27/fatch'} color={`bg-pink text-white`} icon={`fa-regular fa-exclamation-triangle`} class={`shadow-purple`} valueColor={'text-danger'} />
                    <HomeGrid title={`PG Running`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.pg_status : 0} route={'rms_alarm_filter/9/fatch'} color={`bg-danger text-white`} icon={`fa-solid fa-microchip`} class={`shadow-purple`} valueColor={'text-danger'} />

                </div>

                <div className="row g-2 mt-1 mb-2 alarms-container-wrapper">

                    <div className="col-12 col-md-6 rms-card">
                        <fieldset className="border border-dark rounded p-2 bg-white card shadow-sm">
                            <legend className="float-none w-auto fs-12 text-dark">
                                RMS Alarms
                            </legend>

                            <div className=" rms-legend">
                                <div className="card-header bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">

                                        <ul className="nav nav-pills custom-nav-pills" role="tablist">
                                            <li className="nav-item me-2" role="presentation">
                                                <button
                                                    className="nav-link nav-link-custom active"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-active-rms"
                                                    type="button"
                                                    role="tab"
                                                    onClick={() => setFilterType(1)}
                                                >
                                                    <i className="fa-regular fa-bell me-2"></i>
                                                    Active
                                                </button>
                                            </li>

                                            <li className="nav-item me-2" role="presentation">
                                                <button
                                                    className="nav-link nav-link-custom"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-historical-rms"
                                                    type="button"
                                                    role="tab"
                                                    onClick={() => setFilterType(2)}
                                                >
                                                    <i className="fa-solid fa-list me-2"></i>
                                                    Historical
                                                </button>
                                            </li>
                                        </ul>

                                        <div>

                                            <FilterRMS callbackSearch={callbackSearch} filter_type={filter_type} />

                                        </div>

                                    </div>
                                </div>

                                <div className="card-body p-0 m-0 ">
                                    <div className="tab-content p-0 m-0" id="pills-tabContent">
                                        <div className="tab-pane fade show active p-0 m-0" id="pills-active-rms" role="tabpanel" aria-labelledby="pills-active-rms-tab">
                                            <div className="table-responsive  table-list-fixed">

                                                <table className="table table-hover table-striped table-bordered mb-0  ">
                                                    <thead className="table-dark toi-primary text-white">
                                                        <tr>
                                                            <th scope="col">Site ID</th>
                                                            <th scope="col">Tenant Site ID</th>
                                                            <th scope="col">Tenant Name</th>
                                                            <th scope="col">Alarm Name</th>
                                                            <th scope="col">Alarm Start</th>
                                                            <th scope="col">Alarm End</th>
                                                            <th scope="col">Elapsed Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="">
                                                        {rms_active_selector?.loading ? <p className='text-center text-dark fw-medium'>Loading...</p> : ''}
                                                        {rms_active_selector?.alarms?.map((rms_alrm, index) => (
                                                            <tr key={index} ref={index === rms_active_selector?.alarms.length - 1 ? lastRmsActiveElementRef : null}>
                                                                <td><Link to={`/site/${rms_alrm.site_id}`} className={`fw-semibold`}>{rms_alrm.site_id}</Link></td>
                                                                <td>{rms_alrm.tenant_site_id}</td>
                                                                <td className={`fw-semibold ${rms_alrm.tenant_name == 'Banglalink' ? 'text-dark' : (rms_alrm.tenant_name == 'Robi' ? 'text-danger' : (rms_alrm.tenant_name == 'GP' ? 'text-primary' : ''))}`}>{rms_alrm.tenant_name}</td>
                                                                <td className="fw-semibold">{rms_alrm.name}</td>
                                                                <td>{rms_alrm.alarm_start}</td>
                                                                <td>{rms_alrm.alarm_end ? rms_alrm.alarm_end : 'N/A'}</td>
                                                                <td>
                                                                    {rms_alrm.alarm_end != null ?
                                                                        <span className="elisp_time">{rms_alrm.total_elaspsed}</span>
                                                                        :
                                                                        <CountdownTimer targetDate={rms_alrm.alarm_start} />
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                {rms_active_selector?.loading && <div className="text-center">Loading......</div>}


                                            </div>
                                            <p className="p-0 m-0 fs-12">Current Display 1 - {rms_active_selector?.alarms?.length} Record(s), {FormattedNumber(rms_active_selector?.data?.total_page)} Record(s) Totally</p>


                                        </div>
                                        <div className="tab-pane fade p-0 m-0" id="pills-historical-rms" role="tabpanel" aria-labelledby="pills-historical-rms-tab">
                                            <div className="table-responsive  table-list-fixed">
                                                <table className="table table-hover table-striped table-bordered mb-0">
                                                    <thead className="table-dark toi-primary text-white">
                                                        <tr>
                                                            <th scope="col">Site ID</th>
                                                            <th scope="col">Tenant Site ID</th>
                                                            <th scope="col">Tenant Name</th>
                                                            <th scope="col">Alarm Name</th>
                                                            <th scope="col">Alarm Start</th>
                                                            <th scope="col">Alarm End</th>
                                                            <th scope="col">Elapsed Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {selector_rms_alarms?.loading ? <p className='text-center text-dark fw-medium'>Loading...</p> : ''}
                                                        {selector_rms_alarms?.alarms.length > 0 && selector_rms_alarms?.alarms?.map((rms_alrm, index) => (
                                                            <tr key={index} className="bg-white" ref={index === selector_rms_alarms?.alarms.length - 1 ? lastElementRef : undefined}>
                                                                <td><Link to={`/site/${rms_alrm.site_id}`} className="fw-semibold">{rms_alrm.site_id}</Link></td>
                                                                <td>{rms_alrm.tenant_site_id}</td>
                                                                <td className="fw-semibold">{rms_alrm.tenant_name}</td>
                                                                <td className="fw-semibold">{rms_alrm.name}</td>
                                                                <td>{rms_alrm.alarm_start}</td>
                                                                <td>{rms_alrm.alarm_end ? rms_alrm.alarm_end : 'N/A'}</td>
                                                                <td>
                                                                    {rms_alrm.alarm_end != null ?
                                                                        <span className="elisp_time">{rms_alrm.total_elaspsed}</span>
                                                                        :
                                                                        <CountdownTimer targetDate={rms_alrm.alarm_start} />
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                {selector_rms_alarms?.loading && <div className="text-center">Loading......</div>}
                                            </div>
                                            <p className="p-0 m-0 fs-12">Current Display 1 - {selector_rms_alarms?.alarms?.length} Record(s), {FormattedNumber(selector_rms_alarms?.data?.total_page)} Record(s) Totally</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div className="col-12 col-md-6 acs-card">
                        <fieldset className="border border-dark rounded p-2 bg-white card shadow-sm">
                            <legend className="float-none w-auto fs-12 text-dark">
                                ACS Alarms
                            </legend>

                            <div className=" rms-legend">
                                <div className="card-header bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">

                                        <ul className="nav nav-pills custom-nav-pills" role="tablist">
                                            <li className="nav-item me-2" role="presentation">
                                                <button
                                                    className="nav-link nav-link-custom active"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-active-acs"
                                                    type="button"
                                                    role="tab" onClick={() => setAcsFilterType(1)}
                                                >
                                                    <i className="fa-regular fa-bell me-2"></i>
                                                    Active
                                                </button>
                                            </li>

                                            <li className="nav-item me-2" role="presentation">
                                                <button
                                                    className="nav-link nav-link-custom"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-historical-acs"
                                                    type="button"
                                                    role="tab"
                                                    onClick={() => setAcsFilterType(2)}
                                                >
                                                    <i className="fa-solid fa-list me-2"></i>
                                                    Historical
                                                </button>
                                            </li>
                                        </ul>

                                        <div>
                                            <FilterAcs filter_type={acs_filter_type} callbackSearch={callBackAcsSearch} />

                                        </div>

                                    </div>
                                </div>

                                <div className="card-body p-0 m-0">
                                    <div className="tab-content p-0 m-0" id="pills-tabContent">
                                        <div className="tab-pane fade show active p-0 m-0" id="pills-active-acs" role="tabpanel" aria-labelledby="pills-active-acs-tab">
                                            <div className="table-responsive  table-list-fixed">
                                                <table className="table table-hover table-striped table-bordered mb-0">
                                                    <thead className="table-dark toi-primary text-white">
                                                        <tr className="text-uppercase">
                                                            <th scope="col">Site ID</th>
                                                            <th scope="col">Tenant Name</th>
                                                            <th scope="col">Alarm Name</th>
                                                            <th scope="col">Alarm Start</th>
                                                            <th scope="col">Alarm End</th>
                                                            <th scope="col">Elapsed Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {acs_active_selector?.loading ? <p className='text-center text-dark fw-medium'>Loading...</p> : ''}
                                                        {acs_active_selector?.alarms?.map((acs_alrm, index) => (
                                                            <tr key={index} ref={index === acs_active_selector?.alarms.length - 1 ? lastAcsActiveElementRef : null}>
                                                                <td><Link to={`/site/${acs_alrm.site_id}`} className="fw-semibold">{acs_alrm.site_id}</Link></td>
                                                                <td>{acs_alrm.tenant_name ?? 'N/A'}</td>
                                                                <td className="fw-bold">{acs_alrm.name}</td>
                                                                <td>{acs_alrm.alarm_start}</td>
                                                                <td>{acs_alrm.alarm_end ? acs_alrm.alarm_end : 'N/A'}</td>
                                                                <td>
                                                                    {acs_alrm.alarm_end != null ?
                                                                        <span className="elisp_time">{acs_alrm.total_elaspsed}</span>
                                                                        :
                                                                        <CountdownTimer targetDate={acs_alrm.alarm_start} />
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <p className="p-0 m-0 fs-12">Current Display 1 - {acs_active_selector?.alarms?.length} Record(s), {FormattedNumber(acs_active_selector?.data?.total_page)} Record(s) Totally</p>
                                        </div>
                                        <div className="tab-pane fade p-0 m-0" id="pills-historical-acs" role="tabpanel" aria-labelledby="pills-historical-acs-tab">
                                            <div className="table-responsive  table-list-fixed">

                                                <table className="table table-hover table-striped table-bordered mb-0">

                                                    <thead className="table-dark toi-primary text-white">
                                                        <tr>
                                                            <th scope="col">Site ID</th>
                                                            <th scope="col">Tenant Name</th>
                                                            <th scope="col">Alarm Name</th>
                                                            <th scope="col">Alarm Start</th>
                                                            <th scope="col">Alarm End</th>
                                                            <th scope="col">Elapsed Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {lock_alarm_history?.loading ? <p className='text-center text-dark fw-medium'>Loading...</p> : ''}
                                                        {lock_alarm_history?.alarms?.map((data, index) => (
                                                            <tr key={index} ref={index === lock_alarm_history?.alarms.length - 1 ? lastAcsHistoryElementRef : null}>
                                                                <td><Link to={`/site/${data.site_id}`} className="fw-semibold">{data.site_id}</Link></td>
                                                                <td>{data.tenant_name ?? 'N/A'}</td>
                                                                <td className="fw-bold">{data.name}</td>
                                                                <td>{data.alarm_start}</td>

                                                                <td>{data.alarm_end ? data.alarm_end : 'N/A'}</td>
                                                                <td>
                                                                    {data.alarm_end != null ?
                                                                        <span className="elisp_time">{data.total_elaspsed}</span>
                                                                        :
                                                                        <CountdownTimer targetDate={data.alarm_start} />
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                {lock_alarm_history?.loading ? <p className='text-center text-dark fw-medium'>Loading...</p> : ''}
                                            </div>
                                            <p className="p-0 m-0 fs-12">Current Display 1 - {lock_alarm_history?.alarms?.length} Record(s), {FormattedNumber(lock_alarm_history?.data?.total_page)} Record(s) Totally</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                </div>
            </div>
        </>
    )
}